module.exports = __webpack_public_path__ + "static/img/P6.37241f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leishenx/P6.png
// module id = Gowo
// module chunks = 0